import { render } from "./Matches.vue?vue&type=template&id=382ac8de"
import script from "./Matches.vue?vue&type=script&lang=js"
export * from "./Matches.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__